module.exports = __webpack_public_path__ + "static/pod-intro-img-mobile-1-b97da2956804370a353df7c506f8d83a.png";